/**
 * Cocinaeasylunchreporte Archetype
 * 
 * @author Daniel Lepe
 * Agregada la función quicktableFilters y archetypeCocinaeasylunchreporteCFG, útiles para filtar en quicktable y 
 * agregar dependencias de configuración Cocinaeasylunchreporte => Cocinaeasylunchreporte_hijo respectivamente.
 * @date 16 de Agosto, 2024
 * @version 1.1
 * 
 * @author Daniel Lepe
 * @date 16 de Agosto, 2024
 * @version 1.0
 */

import _ from 'lodash'

const baseController = 'Cocinaeasylunchreporte'

const baseIndex = baseController + '/index'

const archetype = () => {
    return [
        // [hidden|number|price|phone|textarea|positivo|password|email]
        {
            key: 'id',
            type: 'hidden'
        }
    ]
};

const captions = [
    // {key: '_'},
    // {kye: encabezado_id_pk},
    // {key: 'mes'},
    // {key: 'menu_clase'}
    { key: 'plan', sortable: true },
    { key: 'receta', sortable: true },
    { key: 'fecha_pedido', sortable: true },
    { key: 'cantidad', sortable: true },
    { key: 'precio', sortable: true },
    { key: 'tipo', sortable: true },
    // { key: 'cede_tipo', label: 'Tipo de sede' },
]

const fechaRango = {
        key: 'fechaRango',
        required: true, // IF THIS IS TRUE, A DEFAULT OPTION SHOULD BE DEFINED, OTHERWISE THE COMPONENT WILL PICK THE FIRST ITEM IN ROW.
        type: 'daterange',
        // default: '2025-01-10', // [YYYY-MM-DD|today|null]
        // default: 'today', // [YYYY-MM-DD|today|null]
    },
    cedesFilter = {
        key: 'sedeName',
        label: 'Filtra por sede', 
        required: false,
        options: [
            // {key: 'any', label: 'Todas las sedes'}
        ]
    },
    // fechaPedido = {
    //     key: 'fechaPedido',
    //     required: true, // IF THIS IS TRUE, A DEFAULT OPTION SHOULD BE DEFINED, OTHERWISE THE COMPONENT WILL PICK THE FIRST ITEM IN ROW.
    //     type: 'date',
    //     // default: '2025-01-10', // [YYYY-MM-DD|today|null]
    //     default: 'today', // [YYYY-MM-DD|today|null]
    // },
    tipoSwitch = {
        key: 'tipoConsulta',
        required: true, // IF THIS IS TRUE, A DEFAULT OPTION SHOULD BE DEFINED, OTHERWISE THE COMPONENT WILL PICK THE FIRST ITEM IN ROW.
        options: [
            // {key: 'Resumen', label: 'Resumen'},
            'Planes',
            'Recetas',
            'Usuarios',
            {key: 'Vista general', label: 'Detalle completo'},
        ]
        // type: 'switch',
        // yesOption: 'Planes',
        // noOption: 'Recetas',
        // default: '2025-01-10', // [YYYY-MM-DD|today|null]
        // default: 'Planes', // [YYYY-MM-DD|today|null]
    };

const quicktableFilters = () => {
    return [
        // fechaPedido,
        cedesFilter,
        fechaRango,
        tipoSwitch
    ]
}

const archetypeCocinaeasylunchreporteCFG = () => {
    return [
        // { key: 'id', type: 'hidden' },
        // { key: 'Cocinaeasylunchreporte_id', type: 'hidden', },
        // { key: 'descriptor', label: 'Description', readonly: true },
    ]
};

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId));
    // console.log("isNil", _.isNil(conceptId))
    return str;
}


export {
    captions,
    baseIndex,
    archetype,
    archetypeCocinaeasylunchreporteCFG,
    quicktableFilters,
    automodalHandler
}